import { getRoleName } from '@app/utils/jwt';

import { ROLES } from '../navigation/types';

export const usePermissions = ({ roles }: { roles: Array<ROLES> }) => {
  const roleName = getRoleName();

  if (roleName === ROLES.ADMIN) {
    return true;
  }

  return !!roleName && roles.includes(roleName as ROLES);
};
